import { get, post } from '@/api/http'

// 获取伙伴等级
export function getCompanyPartne(params) {
  return post('/system/pCompanyPartner/query', params)
}
// 获取公司信息
export function getCompInfo(params) {
  return get('/system/pcompany/getCompWebById', params)
}
// 获取物流圈
export function getCompanySup(params) {
  return post('/system/pcompany/supplierQuery', params)
}
// 保存企业网址
export function saveCompWeb(params) {
  return post('/system/pcompany/saveCompWeb', params)
}
// 获取物流圈
export function getTool(params) {
  return post('/manager/gTool/query', params)
}
// 物流圈公司关注
export function followComp(params) {
  return post('system/pfollow/follow', params)
}
// 物流圈公司取消关注
export function unFollowComp(params) {
  return post('system/pfollow/unFollow', params)
}
// 新闻公告查询
export function getPartice(params) {
  return post('/system/partice/query', params)
}
// 新闻公告保存
export function savePartice(params) {
  return post('/system/partice/save', params)
}
// 用户提交企业网站等待审核
export function pCompanyAuditWeb(params) {
  return post('/system/pcompany/userToAuditWeb', params)
}

// 物流圈公司关注
export function followCompSave(data) {
  return post('system/pfollow/save', data)
}
// 物流圈公司取消关注
export function unFollowCompDel(params) {
  return get('system/pfollow/deleteByFollowId', { params })
}

// 购买vip
export function openVip(data) {
  return post('/system/pcompany/buyVipLevel', data)
}

// 续费vip
export function continueVip(data) {
  return post('/system/pcompany/renewalMember', data)
}
// export function continueVip(data) {
//   return post('/system/pcompany/continuingVipLevel', data)
// }

// 升级vip
export function upVip(data) {
  return post('/system/pcompany/upgradeMember', data)
}

// 获取公司信息
export function companyQuery(data) {
  return post('/system/pcompany/compQuery', data)
}
